import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService } from '../services/storage.service';

@Component({
  selector: 'app-qr-device-redirect',
  templateUrl: './qr-device-redirect.component.html',
  styleUrl: './qr-device-redirect.component.css'
})
export class QrDeviceRedirectComponent implements OnInit{

  constructor(
    public router: Router,
    public storageService: StorageService) {}
  

  public ngOnInit(): void {
    const url = this.router.url;
    const queryPart = url.split('?')[1];
  
    const params = new URLSearchParams(queryPart);
    const serial = params.get('serial_number');
    
    if(this.storageService.isLoggedIn()) {
      this.router.navigate(['/device'], { queryParams: { serial_number: serial } });
    } else {
      this.router.navigate(['/login'], { queryParams: { redirectTo: "/device", serial_number: serial } });
    }
    
  }


}
